import React, { useState } from 'react'
import styled from '@emotion/styled'
import { HiExternalLink } from 'react-icons/hi'
import { Section } from 'components/Common'
import { StepStatus } from 'hooks/useStep'
import {
  ActionCard,
  OutlineButton,
  OpenLeatButton,
  SidePanel,
  SidePanelTitle,
  SidePanelBody
} from './styles'
import { LEAT_APP_URL } from '../../constants'
import {
  AUTH_STEP_TITLE,
  AUTH_STEP_DESCRIPTION,
  EXTERNAL_LINK_PROPS
} from './copy'
import StepLayout from '../Common/StepLayout'
import PatField from './PatField'
import LoadingPrimaryButton from './LoadingPrimaryButton'

interface PatEntryStepProps {
  initialToken?: string
  loading?: boolean
  onContinue: (token: string) => void
  onCancel: () => void
}

const PatEntryStep = ({
  initialToken = '',
  loading,
  onContinue,
  onCancel
}: PatEntryStepProps) => {
  const [token, setToken] = useState(initialToken)

  return (
    <StepLayout
      sidebar={
        <SidePanel>
          <SidePanelImage />
          <SidePanelTitle>Where do I find this?</SidePanelTitle>
          <SidePanelBody>
            Leat dashboard → <strong>Auth</strong> → copy the personal access
            token. If the section is empty, install the Slerp app from
            Leat&apos;s Business Apps Marketplace first.
          </SidePanelBody>
          <OpenLeatButton href={LEAT_APP_URL} {...EXTERNAL_LINK_PROPS}>
            OPEN LEAT <HiExternalLink />
          </OpenLeatButton>
        </SidePanel>
      }
    >
      <Section
        title={AUTH_STEP_TITLE}
        description={AUTH_STEP_DESCRIPTION}
        stepStatus={StepStatus.active}
        stepNumber={1}
      >
        <PatField id='leat-pat' value={token} onChange={setToken} />
      </Section>

      <ActionCard>
        <OutlineButton onClick={onCancel}>CANCEL</OutlineButton>
        <LoadingPrimaryButton
          disabled={!token.trim() || loading}
          loading={loading}
          onClick={() => onContinue(token.trim())}
        >
          CONTINUE
        </LoadingPrimaryButton>
      </ActionCard>
    </StepLayout>
  )
}

const SidePanelImage = styled.div`
  background-color: #d9d9d9;
  border-radius: 6px;
  height: 122px;
  width: 100%;
`

export default PatEntryStep
